/**
 * Brand accent colors for the PolyLLM ChatWithAI subscription modal slot.
 * Kept locally (not re-imported from `ChatPaywallModal/constants`) so this
 * file stays free of webp asset imports and remains test-friendly.
 */
export const TEAL = '#00b39b';
export const STAR_GOLD = '#f5b50a';
